// facets-custom.js — AJAX partial rendering for Megatree filters

(function () {
  if (window.__megatreeInitialized) return;
  window.__megatreeInitialized = true;

  // ─── Helpers ────────────────────────────────────────────────────────────────

  function showLoading() {
    const grid = document.querySelector('.CollectionInner__Products');
    if (grid) {
      grid.style.opacity = '0.4';
      grid.style.pointerEvents = 'none';
      grid.style.transition = 'opacity 0.15s';
    }
  }

  function hideLoading() {
    const grid = document.querySelector('.CollectionInner__Products');
    if (grid) {
      grid.style.opacity = '';
      grid.style.pointerEvents = '';
    }
  }

  function captureExpandStates(formEl) {
    if (!formEl) return [];
    return Array.from(formEl.querySelectorAll('.Collapsible')).map((el, i) => ({
      index: i,
      expanded: el.classList.contains('Collapsible--expanded') ||
                el.querySelector('[aria-expanded="true"]') !== null,
    }));
  }

  function restoreExpandStates(formEl, states) {
    if (!formEl || !states.length) return;
    const collapsibles = formEl.querySelectorAll('.Collapsible');
    states.forEach(({ index, expanded }) => {
      const c = collapsibles[index];
      if (!c) return;
      const btn = c.querySelector('[data-action="toggle-collapsible"]');
      const inner = c.querySelector('.Collapsible__Inner');
      if (expanded) {
        c.classList.add('Collapsible--expanded');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        if (inner) inner.style.display = '';
      }
    });
  }

  function reinitMegatreeGlobals(docFragment) {
    const scripts = docFragment.querySelectorAll('script');
    for (const s of scripts) {
      if (s.textContent.includes('ShopifyMegatree')) {
        try {
          // eslint-disable-next-line no-new-func
          new Function(s.textContent)();
        } catch (e) {
          console.warn('[megatree] failed to re-exec globals script', e);
        }
        break;
      }
    }
  }

  function reinitUI() {
    if (window.lazySizes && window.lazySizes.autoSizer) {
      window.lazySizes.autoSizer.checkElems();
    }
    if (window.lazySizes) {
      document.querySelectorAll('.Image--lazyLoad:not(.lazyloaded):not(.lazyload)').forEach(el => {
        el.classList.add('lazyload');
      });
    }
  }

  // ─── Color swatch delegation ─────────────────────────────────────────────────
  // Attached to the persistent .CollectionInner__Products element so it survives
  // innerHTML swaps (unlike theme's delegate which binds to the replaced .ProductList).

  function initSwatchDelegation() {
    const grid = document.querySelector('.CollectionInner__Products');
    if (!grid) return;

    grid.addEventListener('change', function (e) {
      const radio = e.target.closest('.ColorSwatch__Radio');
      if (!radio) return;

      const productItem = radio.closest('.ProductItem');
      const variantUrl = radio.getAttribute('data-variant-url');
      if (!productItem || !variantUrl) return;

      const imageWrapper = productItem.querySelector('.ProductItem__ImageWrapper');
      const titleLink = productItem.querySelector('.ProductItem__Title > a');
      if (imageWrapper) imageWrapper.setAttribute('href', variantUrl);
      if (titleLink) titleLink.setAttribute('href', variantUrl);

      const originalImage = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
      if (radio.hasAttribute('data-image-url') && originalImage &&
          radio.getAttribute('data-image-id') !== originalImage.getAttribute('data-image-id')) {
        originalImage.src = radio.getAttribute('data-image-url');
        originalImage.setAttribute('data-image-id', radio.getAttribute('data-image-id'));
      }
    });
  }

  // ─── Core AJAX reload ────────────────────────────────────────────────────────

  let _abortController = null;

  function swapElement(selector, tmp, transformFn) {
    const next = tmp.querySelector(selector);
    const current = document.querySelector(selector);
    if (next && current) transformFn ? transformFn(current, next) : (current.innerHTML = next.innerHTML);
  }

  function reloadProducts(url, skipPushState) {
    if (_abortController) _abortController.abort();
    _abortController = new AbortController();

    showLoading();

    if (!skipPushState) {
      history.pushState({ path: url, megatree: true }, '', url);
    }

    fetch(url, { signal: _abortController.signal })
      .then(res => {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(html => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;

        reinitMegatreeGlobals(tmp);

        // Swap product grid
        swapElement('.CollectionInner__Products', tmp, function (current, next) {
          current.innerHTML = next.innerHTML;
          // Theme CSS sets .ProductItem to visibility:hidden as the GSAP stagger base
          // state. GSAP won't re-run after an innerHTML swap, so force items visible.
          current.querySelectorAll('.ProductItem').forEach(function (item) {
            item.style.visibility = 'visible';
            item.style.opacity = '1';
          });
        });

        // Swap filter button / count badge
        swapElement('.CollectionToolbar__Item--filter', tmp, function (current, next) {
          current.innerHTML = next.innerHTML;
          current.className = next.className;
        });

        // Swap filter forms (preserve collapsible expand states)
        ['#collection-filters-drawer-form', '#collection-filters-sidebar-form'].forEach(function (id) {
          const current = document.querySelector(id);
          const next = tmp.querySelector(id);
          if (!current || !next) return;
          const states = captureExpandStates(current);
          current.innerHTML = next.innerHTML;
          restoreExpandStates(current, states);
        });

        // Swap breadcrumbs, title, description
        ['.CollectionBreadcrumbs', '.CollectionHeader__Title', '.CollectionDescription'].forEach(function (sel) {
          swapElement(sel, tmp);
        });

        hideLoading();
        reinitUI();

        const collectionMain = document.querySelector('.CollectionMain');
        if (collectionMain) {
          const top = collectionMain.getBoundingClientRect().top + window.scrollY - 20;
          if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
        }
      })
      .catch(err => {
        if (err.name === 'AbortError') return;
        console.warn('[megatree] AJAX fetch failed, falling back to full navigation', err);
        hideLoading();
        window.location.href = url;
      });
  }

  // ─── Subcollection link handler (called from inline onclick in liquid) ────────

  window.openCustomFacetLink = function (event, href) {
    event.preventDefault();
    event.stopPropagation();
    window.location.href = href;
  };

  // ─── URL builders ────────────────────────────────────────────────────────────

  function getRedirectPath(event, filterForm) {
    const base = window.ShopifyMegatree.url;

    if (event.target.name.startsWith('subcollection')) {
      const collectionsBase = base.substring(0, base.lastIndexOf('/'));
      return collectionsBase + '/' + event.target.value.replace(/\s+/g, '-').toLowerCase();
    }

    if (!event.target.name.startsWith('filter')) {
      return base;
    }

    const currentTags = window.ShopifyMegatree.currentTags || [];
    const currentTag = currentTags.join('+');
    const selectedTag = event.target.value;
    const inputTags = {};
    const inputFilters = {};

    filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
      if (window.ShopifyMegatree.meta[input.value]?.friendly_seo === '1') {
        inputTags[input.value] = input.name;
      } else {
        inputFilters[input.value] = input.name;
      }
    });

    const multiTag = findMultiTag(Object.keys(inputTags));
    const searchParams = [];
    const sortBy = document.querySelector('[name="sort_by"]')?.value;
    if (sortBy) searchParams.push('sort_by=' + sortBy);
    // Build final URL then check/add availability once
const currentParams = new URLSearchParams(window.location.search);
if (!currentParams.has('filter.v.availability')) {
  searchParams.push('filter.v.availability=1');
}

    let redirectPath = base;

    if (multiTag) {
      multiTag.tags.forEach(function (value) { delete inputTags[value]; });
      redirectPath += '/' + multiTag.tag.replace(/\s+/g, '-').toLowerCase();
      Object.entries(inputTags).forEach(([k, v]) => searchParams.push(v + '=' + k));
      Object.entries(inputFilters).forEach(([k, v]) => searchParams.push(v + '=' + k));
    } else {
      if (inputTags[currentTag] && currentTag === selectedTag) {
        delete inputTags[currentTag];
      }
      const tagEntries = Object.entries(inputTags);
      if (tagEntries.length > 0) {
        redirectPath += '/' + tagEntries[0][0].replace(/\s+/g, '-').toLowerCase();
        tagEntries.slice(1).forEach(([k, v]) => { inputFilters[k] = v; });
      }
      Object.entries(inputFilters).forEach(([k, v]) => searchParams.push(v + '=' + k));
    }

    // Always ensure availability=1, deduplicated
const finalParams = new URLSearchParams(searchParams.join('&'));
finalParams.set('filter.v.availability', '1');
redirectPath += '?' + finalParams.toString();

return redirectPath;
  }

  function findMultiTag(tags) {
    let bestMatch = null;
    let maxCount = -1;

    for (const [key, data] of Object.entries(window.ShopifyMegatree.meta)) {
      if (data.multi !== '1') continue;
      const isSubset = data.multi_tags.every(tag => tags.includes(tag));
      if (isSubset && data.multi_tags.length > maxCount) {
        maxCount = data.multi_tags.length;
        bestMatch = { tag: key, tags: data.multi_tags };
      }
    }

    return bestMatch;
  }

  // ─── Filter form listener ─────────────────────────────────────────────────────
  // window capture fires before all other handlers including theme.js.
  // stopImmediatePropagation prevents the theme's competing AJAX from running.

  function initFilterForms() {
    window.addEventListener('click', function (event) {
      let checkbox;
      if (event.target.type === 'checkbox') {
        checkbox = event.target;
      } else {
        const label = event.target.closest('label');
        if (label) {
          checkbox = label.htmlFor
            ? document.getElementById(label.htmlFor)
            : label.querySelector('input[type="checkbox"]');
        }
      }
      if (!checkbox) return;

      const filterForm = checkbox.closest('form.collection-filters-form');
      if (!filterForm || !filterForm.id.includes('filters')) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      checkbox.checked = !checkbox.checked;
      reloadProducts(getRedirectPath({ target: checkbox }, filterForm));
    }, true);
  }

  // ─── Clear-filters handler ────────────────────────────────────────────────────

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-action="clear-filters"]');
    if (!btn) return;
    const href = btn.getAttribute('href') || btn.dataset.href;
    if (!href) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    reloadProducts(href);
  }, true);

  // ─── Back/forward navigation ──────────────────────────────────────────────────

  history.replaceState(
    Object.assign({}, history.state, { path: location.href, megatree: true }),
    '',
    location.href
  );

  window.addEventListener('popstate', function (event) {
    if (event.state && event.state.megatree) {
      event.stopImmediatePropagation();
      reloadProducts(event.state.path, true);
    }
  }, true);

  // ─── Boot ─────────────────────────────────────────────────────────────────────

  function boot() {
    initFilterForms();
    initSwatchDelegation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
